import React from 'react';
import LazyLoad from 'react-lazyload';
import { ThemeProvider } from 'styled-components';
import Menu from '@components/layout/Menu.json';
import Head from '@repo/ui-components/Head';
import PageWrapper from '@repo/ui-components/page-wrapper';
import Header from '@components/header';
import Footer from '@components/footer';
import theme from '@components/theme';
import { GlobalStyles } from '@components/utils/GlobalStyles';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import { InitInsights } from '@repo/utils';
import { Script } from 'gatsby';

InitInsights();

interface LayoutProps {
  children?: React.ReactNode;
  scriptsData?: JSX.Element[];
  fullWidth?: boolean;
}

function Layout({
  children,
  scriptsData = [],
  fullWidth = false,
}: Readonly<LayoutProps>) {
  const scripts = [
    <script
      src="https://kit.fontawesome.com/4dd77ed7cb.js"
      key="fontawesome"
      async
    />,
    <script defer key="mavenoid">
      {`
        (function (m, a, v, e, n, o, i, d) {
          d = m.createElement(a);
          d.async = true;
          d.src =    "https://widget-hosts.mavenoid.com/custom-embedding-scripts/" + n + ".js";
          i = m.getElementsByTagName(a)[0];
          i.parentNode.insertBefore(d, i);
          v[e] = v[e] || [];
        })(document, "script", window, "mavenoid", "radio-systems-corp");
      `}
    </script>,
    ...scriptsData,
  ];

  return (
    <ThemeProvider theme={theme}>
      <Head scriptTags={scripts} />
      <GlobalStyles />
      <Header
        menuStructure={Menu}
        searchIndexes={['petsafe-support-articles', 'petsafe-support-pages']}
      />
      <PageWrapper $fullWidth={fullWidth} $background="inherit" $padding="0">
        <main style={{ minHeight: '64.4vh' }}>{children}</main>
      </PageWrapper>
      <LazyLoad offset={100}>
        <Footer />
      </LazyLoad>
      {process.env.GATSBY_COOKIEPRO_SITE_ID && [
        <Script
          key="otSDKStub"
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          data-domain-script={process.env.GATSBY_COOKIEPRO_SITE_ID}
        />,
      ]}
    </ThemeProvider>
  );
}

export default Layout;
